import { sendBlogEvent } from './analytics.js';

/**
 * Initialize copy-link share button on post pages.
 */
export function initShareCopy() {
  const shareButton = document.querySelector('.post-header__share');
  if (!shareButton) return;

  const tooltipClassVisible = 'post-header__share-tooltip--visible';

  let tooltip = shareButton.querySelector('.post-header__share-tooltip');
  if (!tooltip) {
    tooltip = document.createElement('span');
    tooltip.className = 'post-header__share-tooltip';
    tooltip.textContent = 'コピーしました';
    tooltip.setAttribute('aria-hidden', 'true');
    shareButton.appendChild(tooltip);
  }

  /**
   * Copy provided text to clipboard with a fallback for older browsers.
   * @param {string} text
   * @returns {Promise<void>}
   */
  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise((resolve, reject) => {
      try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.top = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  function showTooltip() {
    tooltip.classList.add(tooltipClassVisible);

    if (shareButton._copyTooltipTimeout) {
      clearTimeout(shareButton._copyTooltipTimeout);
    }

    shareButton._copyTooltipTimeout = setTimeout(() => {
      tooltip.classList.remove(tooltipClassVisible);
    }, 2000);
  }

  shareButton.addEventListener('click', async (event) => {
    event.preventDefault();

    const canonicalLink = document.querySelector('link[rel="canonical"]');
    const urlToCopy = canonicalLink ? canonicalLink.href : window.location.href;

    try {
      await copyToClipboard(urlToCopy);
      showTooltip();
      sendBlogEvent('share_copy', {
        post_slug: window.GhostConfig?.post?.slug || '',
        shared_url: urlToCopy
      });
    } catch {
      showTooltip();
    }
  });
}

